/* tslint:disable */
/* eslint-disable */
/**
 * resident-resources
 * resident-resources
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TaskExtensionTag } from './TaskExtensionTag';
import {
    TaskExtensionTagFromJSON,
    TaskExtensionTagFromJSONTyped,
    TaskExtensionTagToJSON,
} from './TaskExtensionTag';

/**
 * 
 * @export
 * @interface FindAllTaskExtensionTags200Response
 */
export interface FindAllTaskExtensionTags200Response {
    /**
     * 
     * @type {Array<TaskExtensionTag>}
     * @memberof FindAllTaskExtensionTags200Response
     */
    data?: Array<TaskExtensionTag>;
}

/**
 * Check if a given object implements the FindAllTaskExtensionTags200Response interface.
 */
export function instanceOfFindAllTaskExtensionTags200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllTaskExtensionTags200ResponseFromJSON(json: any): FindAllTaskExtensionTags200Response {
    return FindAllTaskExtensionTags200ResponseFromJSONTyped(json, false);
}

export function FindAllTaskExtensionTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllTaskExtensionTags200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TaskExtensionTagFromJSON)),
    };
}

export function FindAllTaskExtensionTags200ResponseToJSON(value?: FindAllTaskExtensionTags200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TaskExtensionTagToJSON)),
    };
}

